export enum CertificateType {
  ViverBem = 1,
  SempreBemRefriPay = 2,
  ProtegeRefriBem = 3,
  Pleno = 4,
  ApHome = 5,
  ApFacilPremiavel = 6,
  ColetivoBrasilSeguros = 7,
  ColetivoFMJ = 8,
  MaisFortune = 9,
  ExtraFortune = 10,
  EssencialFortune = 11,
  SemCertificado = 'SemCertificado',
}

export enum ContractType {
  WELFARE = 1,
  FINANCIAL_ASSISTANCE = 2,
  INSURANCE = 3,
}

export enum ContractInstallmentStatus {
  PAGO = 'Pago',
  EM_ABERTO = 'Em aberto',
  A_VENCER = 'Á vencer',
  REGULARIZAR = 'Regularizar',
}

export enum ContractPaymentType {
  DEBIT = 'Debit',
  CREDIT_CARD = 'Credit_Card',
  PAYROLL_DISCOUNT = 'PayrollDiscount',
}

export interface ContractBenefit {
  id: number;
  title: string;
  description: string;
  icon: string;
  contact?: {
    id: number;
    description: string;
    phone?: string;
    url?: string;
  };
  active: string;
  createdOn: string;
  modifiedOn: string;
}

export interface ContractInstallment {
  expirationDate: string;
  installmentNumber: number;
  status: string;
  price: number;
  period: string;
  paymentDate: string;
  frequency: string;
}

export interface ContractPayment {
  type: ContractPaymentType;
}

export interface ContractValidity {
  startDate: Date;
  endDate: Date;
}

export interface ContractBeneficiary {
  cpf: string;
  idContract?: string;
  name: string;
  kinshipDegree: string;
  indemnityPercent: string;
}

export interface ContractMembershipProposal {
  fileBase64: string;
}

export interface Contract {
  id: string;
  idProductType: ContractType;
  name: string;
  signatureDate: string;
  organName: string;
  price: number;
  luckyNumber: string;
  currentInstallmentNumber: number; // TODO :: Segregate to a installments object
  lastInstallmentNumber: number;
  certificateType: string;
  digitalChannel: boolean;
  isPropostaWeb: boolean;

  payment: ContractPayment;

  beneficiaries: ContractBeneficiary[];
  validity: ContractValidity;

  benefits: ContractBenefit[];
  installments: ContractInstallment[];

  active: boolean;

  modified_on: string;
}
